import { FocusStyleManager } from '@blueprintjs/core'
import i18next from 'i18next'
import { throttle } from 'lodash'
import deleteAnonymousUserData from '../../backend/deleteAnonymousUserData'
import { globalOnDemandVars } from '../../helper/context'
import { showToastByMenuDirection } from '../../helper/functions'

FocusStyleManager.onlyShowFocusOnTabs()

window.addEventListener('offline', () => {
  globalOnDemandVars.set_isOnline(false)
  showToastByMenuDirection({
    message: i18next.t('It\'s offline mode'),
    intent: 'warning'
  })
})
window.addEventListener('online', throttle(() => {
  globalOnDemandVars.set_isOnline(true)
  showToastByMenuDirection({
    message: i18next.t('It\'s online mode'),
    intent: 'success'
  })
}, 1000 * 60 * 5, { leading: false, trailing: true }))

if (process.env.NODE_ENV === 'production') {
  window.addEventListener('beforeunload', () => {
    if (process.env.NODE_ENV === 'production') {
      window.analytics.track('User Left', {
        totalTime: (new Date()) - globalOnDemandVars.timeRecords().total
      })
    }

    deleteAnonymousUserData()
  })
}

// alert('!')
